export enum WebcastViewSidebarButton {
	ATTENDEES = 'Attendees',
	CHAT = 'chat',
	INFO = 'info',
	POLLS = 'polls',
	QA = 'questions',
	RTA = 'realTimeAnalytics'
}
